// URL de base de l'API — SOURCE UNIQUE DE VÉRITÉ
//
// • dev  : VITE_API_URL non défini → fallback http://localhost:18000/api
//          (backend exposé en direct, cf. docker-compose.dev.yml)
// • prod : VITE_API_URL fourni au build (ARG docker/frontend/Dockerfile)
//          → https://<domaine>/api
//
// ⚠️ Ne JAMAIS réécrire l'URL en dur dans une page : toujours importer
//    API_BASE depuis "@/lib/apiBase".

export const API_BASE =
  (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/+$/, "") ??
  "http://localhost:18000/api";

/** Construit une URL absolue d'endpoint à partir de l'API_BASE. */
export const apiUrl = (path: string): string =>
  `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
